"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTypeKeysEnum = void 0;
var ActionTypeKeysEnum;
(function (ActionTypeKeysEnum) {
    ActionTypeKeysEnum["OrderRequest"] = "orderRequest";
    ActionTypeKeysEnum["CancellationRequest"] = "cancellationRequest";
    ActionTypeKeysEnum["AddressChangeRequest"] = "addressChangeRequest";
    ActionTypeKeysEnum["ArtworkChangeRequest"] = "artworkChangeRequest";
    ActionTypeKeysEnum["ShipmentRequirementChangeRequest"] = "shipmentRequirementChangeRequest";
    ActionTypeKeysEnum["RejectItems"] = "rejectItems";
    ActionTypeKeysEnum["SetItemsToProduction"] = "setItemsToProduction";
    ActionTypeKeysEnum["ShipItems"] = "shipItems";
    ActionTypeKeysEnum["AcceptOrderRequest"] = "acceptOrderRequest";
    ActionTypeKeysEnum["RejectOrderRequest"] = "rejectOrderRequest";
    ActionTypeKeysEnum["AcceptCancellationRequest"] = "acceptCancellationRequest";
    ActionTypeKeysEnum["RejectCancellationRequest"] = "rejectCancellationRequest";
    ActionTypeKeysEnum["AcceptAddressChangeRequest"] = "acceptAddressChangeRequest";
    ActionTypeKeysEnum["RejectAddressChangeRequest"] = "rejectAddressChangeRequest";
    ActionTypeKeysEnum["AcceptArtworkChangeRequest"] = "acceptArtworkChangeRequest";
    ActionTypeKeysEnum["RejectArtworkChangeRequest"] = "rejectArtworkChangeRequest";
    ActionTypeKeysEnum["AcceptShipmentRequirementChangeRequest"] = "acceptShipmentRequirementChangeRequest";
    ActionTypeKeysEnum["RejectShipmentRequirementChangeRequest"] = "rejectShipmentRequirementChangeRequest";
    ActionTypeKeysEnum["ProvideItemsInformation"] = "provideItemsInformation";
    ActionTypeKeysEnum["DelayItems"] = "delayItems";
    ActionTypeKeysEnum["ProductionHoldItems"] = "productionHoldItems";
})(ActionTypeKeysEnum = exports.ActionTypeKeysEnum || (exports.ActionTypeKeysEnum = {}));
